/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Roles_Manage_Permissions_DescriptionInputs */

const en_admin_roles_manage_permissions_description = /** @type {(inputs: Admin_Roles_Manage_Permissions_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select permissions for this role`)
};

/**
* | output |
* | --- |
* | "Select permissions for this role" |
*
* @param {Admin_Roles_Manage_Permissions_DescriptionInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_roles_manage_permissions_description = /** @type {((inputs?: Admin_Roles_Manage_Permissions_DescriptionInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Roles_Manage_Permissions_DescriptionInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_roles_manage_permissions_description(inputs)
});
export { admin_roles_manage_permissions_description as "admin.roles.manage_permissions_description" }